/* eslint-disable @typescript-eslint/no-var-requires */
import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import { metrics, ResponsivePictureLayout } from '@news-mono/component-library'
import { StaticRoutes, Topic } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { getTopicSponsor } from '../../topic/get-topic-sponsor'

const bannerDesktopX2 = require<string>('./assets/foul-play-feature-banner-lg@2x.jpg')

const bannerDesktopX1 = require<string>('./assets/foul-play-feature-banner-lg@1x.jpg')

const bannerTabletX2 = require<string>('./assets/foul-play-feature-banner-md@2x.jpg')

const bannerTabletX1 = require<string>('./assets/foul-play-feature-banner-md@1x.jpg')

const bannerMobileX2 = require<string>('./assets/foul-play-feature-banner-sm@2x.jpg')

const bannerMobileX1 = require<string>('./assets/foul-play-feature-banner-sm@1x.jpg')

const socialImage = require('./assets/foul-play-social-share.jpg')

export const getSocialImageMeta = [
    {
        property: 'og:image',
        content: socialImage,
    },
    { name: 'twitter:image', content: socialImage },
    {
        property: 'og:image:height',
        content: '627',
    },
    {
        property: 'og:image:width',
        content: '1220',
    },
]

const topic: Topic = {
    id: 'features/foul-play',
    metadata: {},
    seoTitle: `FOUL PLAY: The Tiny Pinder Story`,
    title: `FOUL PLAY: The Tiny Pinder Story`,
    seoDescription: `5-part docuseries on one of basketball's most exciting players, Perth Wildcat Tiny Pinder, investigating his crimes, and how he got away with it for so long. Subscribe and watch it now at thewest.com.au`,
    parent: {
        id: 'features',
        metadata: {},
        seoTitle: 'Features',
        title: 'Features',
    },
}

export const getFoulPlayRouteInfo: StaticRoutes<TheWestSection> = {
    '/features/foul-play': ({ getAdTargeting, config, store }) => {
        const canonicalUrl = config.publicUrl + '/features/foul-play'

        const enableRoute = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'foul-play-editorial-feature',
        )

        const geoBlockEnabled = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'geoblock-nsw-foul-play',
        )

        if (!enableRoute) {
            return null
        }

        // Redirect to /page-is-unavailable if the user is accessing the page from NSW
        const geoLocation = store.getState().geoLocation
        const isGeoLocationBlocked =
            geoBlockEnabled &&
            ((geoLocation.userSelectedRegion === 'NSW' &&
                geoLocation.countryCode === 'AU') ||
                (geoLocation.countryCode === 'AU' &&
                    geoLocation.region === 'NSW'))

        if (isGeoLocationBlocked) {
            return {
                kind: 'page',
                heading: 'Page is Unavailable',
                hideHeading: true,
                pageType: 'static',
                adTargeting: {
                    pageId: 'diag',
                    adUnitPath: '',
                    ssAdUnits: [],
                    topics: [],
                },
                section: 'default',
                compositions: [
                    layout.composition({
                        type: 'box',
                        props: {},
                        contentAreas: {
                            main: [
                                layout.component({
                                    type: 'redirector',
                                    props: {
                                        getRedirectPathFromState: () =>
                                            `/page-is-unavailable`,
                                        status: 302,
                                    },
                                }),
                            ],
                        },
                    }),
                ],
            }
        }

        return {
            kind: 'page',
            heading: topic.title,
            pageType: 'video-series',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta,
            },
            socialMeta: {
                title: topic.seoTitle,
                description: topic.seoDescription,
            },
            adTargeting: getAdTargeting('home', 'default', topic.id),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'box',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        verticalGutters: ['outerMargin', 'unset'],
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'breaking-news',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'breaking-news',
                                        offset: 0,
                                        pageSize: 1,
                                    },
                                },
                            }),
                            layout.component({
                                type: 'breaking-news-promo-strap',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'breaking-news-promo-strap',
                                        offset: 0,
                                        pageSize: 1,
                                    },
                                },
                            }),
                            layout.component({
                                type: 'breadcrumb',
                                props: {
                                    topic,
                                    sponsor: getTopicSponsor(topic),
                                    enableHeaderTag: true,
                                    horizontalGutters: 'outerMargin',
                                },
                            }),
                        ],
                    },
                }),
                layout.composition({
                    type: 'thor',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'image-banner',
                                props: {
                                    defaultSrc: bannerDesktopX2,
                                    verticalGutters: ['unset', 'md'],
                                    altText:
                                        'Foul Play - The Tiny Pinder Story',
                                    sources: [
                                        {
                                            breakpoint: 'md',
                                            src: [
                                                {
                                                    src: bannerDesktopX2,
                                                    density: '2x',
                                                },
                                                {
                                                    src: bannerDesktopX1,
                                                    density: '1x',
                                                },
                                            ],
                                        },
                                        {
                                            breakpoint: 'xs',
                                            src: [
                                                {
                                                    src: bannerTabletX2,
                                                    density: '2x',
                                                },
                                                {
                                                    src: bannerTabletX1,
                                                    density: '1x',
                                                },
                                            ],
                                        },
                                        {
                                            src: [
                                                {
                                                    src: bannerMobileX2,
                                                    density: '2x',
                                                },
                                                {
                                                    src: bannerMobileX1,
                                                    density: '1x',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            }),
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    layoutRatio: '3:1',
                                    stretchColumns: true,
                                    verticalSpacing: 'xl',
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'sierra',
                                            props: {
                                                fixedRatios: ['16:9'],
                                                heroImageLayout:
                                                    ResponsivePictureLayout.ObjectFitContain,
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                    maxBreakpoint: 'md',
                                                },

                                                cardLayout: ['hero-video'],
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'foul-play',
                                                    offset: 0,
                                                    pageSize: 1,
                                                },
                                            },
                                        }),
                                    ],
                                    right: [
                                        layout.component({
                                            type: 'tw-subscribe-promo-card',
                                            props: {},
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'xl',
                                    fontScale: 1.2,
                                    fixedRatios: ['16:9'],
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    hasBackground: true,
                                    sectionHeader: {
                                        heading: 'Watch the episodes',
                                    },

                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'foul-play',
                                        offset: 1,
                                        pageSize: 8,
                                    },
                                },
                            }),
                            ...billboardLeaderboardMrec('one'),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'md',
                                    fontScale: 1.2,
                                    fixedRatios: ['16:9'],
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    hasBackground: true,
                                    loadMoreEnabled: true,
                                    sectionHeader: {
                                        heading: 'Latest Tiny Pinder News',
                                    },

                                    dataDefinitionArgs: {
                                        type: 'listing',
                                        topics: ['news/tiny-pinder'],
                                        includeSubTopics: true,
                                        paging: {
                                            page: 1,
                                            pageSize: 8,
                                            pageOffset: 0,
                                        },
                                    },
                                },
                            }),
                            ...billboardLeaderboardMrec('two'),
                        ],
                    },
                }),
            ],
        }
    },
}
